import { VEHICLE_SEARCH_URL } from '../constants'
import { SearchResponse } from '../types/vehicle-counts'

export const getSearchAPIData = async (): Promise<SearchResponse> => {
  const response = (await fetch(VEHICLE_SEARCH_URL).then((res) =>
    res.json(),
  )) as SearchResponse
  return response
}

export const getSelectedVehiclesAPIData = async (
  vehicleIds: string,
): Promise<SearchResponse> => {
  const response = (await fetch(
    `${VEHICLE_SEARCH_URL}?vehicleIds=${vehicleIds}&excludeUnavailable=false&queryOnly=true`,
  ).then((res) => res.json())) as SearchResponse
  return response
}
